import { Injectable } from '@angular/core';
import { BBResponseContainer } from '../common-services/response-container';
import { Observable } from 'rxjs';
import { HttpParams, HttpClient } from '@angular/common/http';
import { environment } from "../../environments/environment";
import { map, tap, timeout } from 'rxjs/operators';
import { RunDetails } from './model/RunDetails';
import { runProcessdto } from './model/runProcessdto';
import { DirectPrintRequest } from '../print-plate-labels/ngs-print-request';

@Injectable({
  providedIn: 'root'
})
export class RunplanProcessService {
  
  constructor(private http: HttpClient) { }
  
  getRunForLabAndRunId(labId: string, runId: string): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/runProcess";
    let requestParam = new HttpParams().set('lab', labId).set('run', runId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

  saveComment(runID: string, labId: string, comment: any): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/comment/"+runID+"/"+labId;
    return this.http.patch<BBResponseContainer>(url, comment).pipe(timeout(environment.defaultTimeout));
  }

  prepareDataForAnalysis(RunPublishDTO: runProcessdto) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/save";
    return this.http.post<BBResponseContainer>(url, RunPublishDTO).pipe(timeout(environment.defaultTimeout));
  }
  
  downloadSampleSheet(downloadType: string, jsonString: string) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + '/api/excel/download';
    let jsonRequest = {'downloadType': downloadType, 'requestParam': jsonString}
    return this.http.put(url, jsonRequest, { observe: 'response', responseType: 'blob' }).pipe(
      map((res) => {
        return {
          fileContent: new Blob([res.body], { type: res.headers.get('content-Type') }),
          filename: res.headers.get('filename')
        }
      })
    );
  }
  
  getListOfLaneView(formData:any): Observable<any> {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/laneView";
    return this.http.put<BBResponseContainer>(url, formData).pipe(timeout(environment.defaultTimeout), tap(error => {
      error.url = url;
    }));
  }
  updateRunStatus(selectedRun: RunDetails) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/status";
    return this.http.put<BBResponseContainer>(url, selectedRun).pipe(timeout(environment.defaultTimeout));
  }

  redoRun(selectedRun: RunDetails) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/sequencing/redo";
    return this.http.put<BBResponseContainer>(url, selectedRun).pipe(timeout(environment.defaultTimeout));
  }

  removeLibs(selectedRun: RunDetails) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/sequencing/remove/libs";
    return this.http.put<BBResponseContainer>(url, selectedRun).pipe(timeout(environment.defaultTimeout));
  }

  getUnKownTagCSV(lab:string,laneId:string,runId:string) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/unknownTags/csv"
    let requestParam = new HttpParams().set('lab', lab).set('laneId', laneId).set('runId',runId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

  getFilterdStatusList(reqObj:any){
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/run/status/list";
    return this.http.put<BBResponseContainer>(url, reqObj).pipe(timeout(environment.defaultTimeout));
  }
  saveFinalConcentrationForLane(requestBody: any) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/final/concentration";
    return this.http.put<BBResponseContainer>(url, requestBody).pipe(timeout(environment.defaultTimeout));
  }

  startDnP(requestBody: any) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/startdnp";
    return this.http.put<BBResponseContainer>(url, requestBody).pipe(timeout(environment.defaultTimeout));
  }

  uploadHamiltonLogFile(formData: FormData) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + 'api/file/upload';
    return this.http.post<BBResponseContainer>(url, formData).pipe(timeout(environment.defaultTimeout));
  }

  downloadDilutionAndPoolingWorkfile(requestObj: any) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + '/runplan/dnp/hamilton/workfile';
    return this.http.put(url, requestObj, { observe: 'response', responseType: 'blob'}).pipe(
      map((res) => {
        return {
          fileContent: new Blob([res.body], { type: res.headers.get('content-Type') }),
          filename: res.headers.get('Content-Disposition')
        }
      })
    );
  }

  saveToWorkfiles(requestObj: any) {
    let url = environment.BB_NGS_LIB_PREP_URL + '/library/workfiles';
    return this.http.put(url, requestObj).pipe(timeout(environment.defaultTimeout));
  }
  
  updateQCstatus(reqBody: any){
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/storeRunQCDecisionForLibs";
    return this.http.put<BBResponseContainer>(url, reqBody).pipe(timeout(environment.defaultTimeout));
  }

  sendRunQCStatusToMint(reqObj: any){
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/send/runQCStatus";
    return this.http.put<BBResponseContainer>(url, reqObj).pipe(timeout(environment.defaultTimeout));
  }

  startCompletionDnP(requestObj: any) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/dnp/complete/start";
    return this.http.put<BBResponseContainer>(url, requestObj).pipe(timeout(environment.defaultTimeout));
  }

  endCompletionDnP(requestObj: any) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/dnp/complete/end";
    return this.http.put<BBResponseContainer>(url, requestObj).pipe(timeout(environment.defaultTimeout));
  }

  printSampleLabels(printRequest: DirectPrintRequest): Observable<BBResponseContainer> {
    let url = environment.BB_PRINT_SERVICE_URL + 'printLabel'
    return this.http.post<BBResponseContainer>(url, printRequest);
  }

  updateLibraryConcentration(requestObj: any): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_RUN_PLANNING_URL + 'runplan/library/concentration';
    return this.http.put<BBResponseContainer>(url, requestObj);
  }
}
